var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"workFlowRef",staticClass:"workflow"},[_c('WorkflowViewport',[_c('EdgeRenderer'),_c('div',{staticClass:"workflow__edge-labels"}),_c('NodeRenderer'),_vm._t("zoom-pane")],2),_c('WorkflowBackground'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }